// smooth scroll to anchor, with option of hash appearing in url.
$(document).ready(function(){
  $('a[href^="#"]').on('click',function (e) {
    e.preventDefault();
    var target = this.hash;
    var $target = $(target);
    $('html, body').stop().animate({
      'scrollTo': $target.offset().top
    }, 900, 'swing', function () {
      	// window.location.hash = target;
    });
  });
});